<template>
  <div class="calc-result-wrapper flex-column">
    <div class="flex-column gap16 w-full">
      <el-tooltip effect="light" placement="top" :hide-after="3000">
        <div slot="content">
          <p class="tip-content-text">{{ $t("nodelist.annual1") }}</p>
        </div>
        <span class="title">
          {{ $t("calculator.result") }}
          <img
            src="~assets/img/table/info-circle1.png"
            style="transform: translateY(-1px);"
          />
        </span>
      </el-tooltip>
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.totalrate") }}
        </div>
        <div class="content bold">
          {{ this.totalRate }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.totalong") }}
        </div>
        <div class="content bold">
          {{ this.totalAmount }}
        </div>
      </div>
    </div>
    <div class="flex-column gap16 w-full">
      <div class="title">{{ $t("calculator.detail") }}</div>
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.feerate") }}
        </div>
        <div class="content bold">
          {{ this.feeRate }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.feeong") }}
        </div>
        <div class="content bold">
          {{ this.feeAmount }}
        </div>
      </div>
    </div>
    <div class="flex-column gap16 w-full">
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.releaserate") }}
        </div>
        <div class="content bold">
          {{ this.releasedRate }}
        </div>
      </div>
      <div class="flex w-full">
        <div class="content thin">
          {{ $t("calculator.releaseong") }}
        </div>
        <div class="content bold">
          {{ this.releasedONG }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalRate: {
      type: String,
      default: ''
    },
    totalAmount: {
      type: Number,
    },
    feeRate: {
      type: String
    },
    feeAmount: {
      type: String
    },
    releasedRate: {
      type: String
    },
    releasedONG: {
      type: String
    }
  }
}
</script>
<style scoped lang="scss">
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.calc-result-wrapper {
  box-sizing: border-box;
  gap: 32px;
  padding: 40px 36px;
  width: 428px;
  height: 317px;
  background: #FFFFFF;
  border-radius: 20px;

  @include mobile {
    padding: 40px 20px;
    width: 100%;
    margin-bottom: 24px;
    white-space: nowrap;
  }
}
.title {
  height: 20px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: rgba(#181717, 0.8);
}
.gap16 {
  gap: 16px;
}
.content {
  font-size: 14px;
  line-height: 10px;
  letter-spacing: -0.03em;
  color: #181717;
}
.thin {
  font-weight: 300;
}
</style>